import { render, staticRenderFns } from "./AbkAddButton.vue?vue&type=template&id=2af44bc5&scoped=true&"
import script from "./AbkAddButton.vue?vue&type=script&lang=js&"
export * from "./AbkAddButton.vue?vue&type=script&lang=js&"
import style0 from "./AbkAddButton.vue?vue&type=style&index=0&id=2af44bc5&lang=scss&scoped=true&"
import style1 from "./AbkAddButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af44bc5",
  null
  
)

export default component.exports